import ChatInterface from './components/ChatInterface';

function App() {
  return (
    <div>
      <ChatInterface />
    </div>
  );
}

export default App;
